import { Box, Button, Divider, Icon, IconButton, Popover, Skeleton, Stack, Typography } from "@mui/material";
import { blue, grey, lightBlue } from "@mui/material/colors";
import { GlobalState } from "context/GlobalContext";
import { ReportsState } from "context/ReportsContext";
import TableDisplay from "./TableDisplay/TableDisplay";
import { useEffect, useState } from "react";
import {
	achievedColumns,
	blueRenderCell,
	blueShade,
	bqDataUpdateColumnsMap,
	brandColumn,
	brandLevelTableColumns,
	channelColumn,
	daysLeftColumn,
	projectionColumns,
	sqlDataUpdateColumnsMap,
	staticBrandWiseData,
	staticChannelWiseData,
	staticCombinedData,
	unitRow,
} from "./data";
import moment from "moment";
import ProjectionEditModal from "./ProjectionEditModal/ProjectionEditModal";
import { converAttrToDatagridCol, getColDefaultValue } from "data/globalData";
import { EditRounded } from "@mui/icons-material";
import MonthYearSelectorModal from "./MonthYearSelectionModal/MonthYearSelectionModal";
import axios from "axios";
import { multiSort } from "utils/multiColumnSort";
const AopTracker = () => {
	const { setSnackBarOpen, setSnackBar, snackbar, LoadingOpen, setLoadingOpen } = GlobalState();
	const { reportLoading, setReportLoading, saleImDropdowns, setSaleImDropdowns } = ReportsState();

	const [brandWiseData, setBrandWiseData] = useState(staticBrandWiseData);
	const [pageLoading, setPageLoading] = useState(false);
	const [channelWiseData, setChannelWiseData] = useState(staticChannelWiseData);
	const [combinedData, setCombinedData] = useState(staticCombinedData);
	const [projectionEditModal, setProjectionEditModal] = useState(false);
	const [monthYearModal, setMonthYearModal] = useState(false);
	const [selectedMonth, setSelectedMonth] = useState(+moment().format("M") - 1);
	const [selectedYear, setSelectedYear] = useState(+moment().format("YYYY"));
	const [daysLeft, setDaysLeft] = useState(0);
	const [pageData, setPageData] = useState();
	console.log("dmhmfgjsdf", selectedMonth, +moment().format("M"));

	const fetchBqData = async () => {
		try {
			const res = await axios.get(`/api/aop/get_bq_sale_data?month=${selectedMonth}&year=${selectedYear}`);
			return res.data.result;
		} catch (error) {
			return [];
		}
	};

	const fetchSQLData = async () => {
		try {
			const res = await axios.get(`/api/aop/get_aop_data?month=${selectedMonth}&year=${selectedYear}`);
			return res.data.result;
		} catch (error) {
			return [];
		}
	};
	const fetchPageDataFromScratch = async () => {
		try {
			setPageLoading(true);
			const [bqData, sqlData] = await Promise.all([fetchBqData(), fetchSQLData()]);

			const distinctBrands = [
				...new Set(
					[...bqData, ...sqlData].reduce((acc, row) => {
						if (row?.[brandColumn.key]) acc.push(row?.[brandColumn.key]);

						return acc;
					}, [])
				),
			];
			const distinctChannels = [
				...new Set(
					[...bqData, ...sqlData].reduce((acc, row) => {
						if (row?.[channelColumn.key]) acc.push(row?.[channelColumn.key]);

						return acc;
					}, [])
				),
			];

			const defBqRowData = { aop_ach: 0, cogs: 0, taxable_amount: 0, qty: 0 };
			const defSqlRowData = { aop_ach: 0, cogs: 0, taxable_amount: 0, qty: 0 };

			const setBqDataInRow = (bqRow, rowToUpdate) => {
				return {
					...rowToUpdate,
					aop_ach: rowToUpdate["aop_ach"] + bqRow["aop_ach"],
					cogs: rowToUpdate["cogs"] + bqRow["cogs"],
					aop_ach: rowToUpdate["aop_ach"] + bqRow["aop_ach"],
					taxable_amount: rowToUpdate["taxable_amount"] + bqRow["taxable_amount"],
					qty: rowToUpdate["qty"] + bqRow["qty"],
				};
			};

			const setSQLDataInRow = (sqlRow, rowToUpdate) => {
				return {
					...rowToUpdate,
					projected_sales: rowToUpdate["projected_sales"] + sqlRow["projected_sales"],
					projected_gp_val: rowToUpdate["projected_gp_val"] + sqlRow["projected_gp_val"],
					taxable_amount: rowToUpdate["taxable_amount"] + sqlRow["taxable_amount"],
					qty: rowToUpdate["qty"] + sqlRow["qty"],
				};
			};

			const combineBqAndSqlDataOnBrandChannel = (sqlData, bqData) => {
				const set = new Set(
					[...sqlData, ...bqData]?.map((row) => {
						return `${row.brand ?? "BR"}-${row.channel ?? "CH"}`;
					}, [])
				);
				const sqlDataObj = sqlData?.reduce((acc, row) => {
					acc[`${row.brand ?? "BR"}-${row.channel ?? "CH"}`] = row;
					return acc;
				}, {});
				const bqDataObj = bqData?.reduce((acc, row) => {
					acc[`${row.brand ?? "BR"}-${row.channel ?? "CH"}`] = row;
					return acc;
				}, {});
				const res = [...set].map((key) => {
					let obj = {};
					if (sqlDataObj[key]) obj = { ...obj, ...sqlDataObj[key] };
					if (bqDataObj[key]) obj = { ...obj, ...bqDataObj[key] };
					return obj;
				});
				const thor = res
					.filter((row) => row[brandColumn.key] === "THOR")
					.sort(
						multiSort([
							{ key: "brand", order: "asc" },
							{ key: "aop_ach", order: "desc" },
						])
					);
				const withoutThor = res
					.filter((row) => row[brandColumn.key] !== "THOR")
					.sort(
						multiSort([
							{ key: "brand", order: "asc" },
							{ key: "aop_ach", order: "desc" },
						])
					);
				setPageLoading(false);

				return [...thor, ...withoutThor];
			};

			setBrandWiseData(
				Object.values(
					distinctBrands.reduce((acc, brand) => {
						let dataRow = { [brandColumn.key]: brand, ...defBqRowData, ...defSqlRowData };
						bqData
							?.filter((row) => row?.[brandColumn.key] === brand)
							.forEach((bqRow) => {
								dataRow = setBqDataInRow(bqRow, dataRow);
							});
						sqlData
							?.filter((row) => row?.[brandColumn.key] === brand)
							.forEach((sqlRow) => {
								Object.values({ ...achievedColumns, ...projectionColumns })
									.filter((col) => sqlDataUpdateColumnsMap.hasOwnProperty(col.key))
									.forEach((col) => (dataRow = setSQLDataInRow(sqlRow, dataRow)));
							});
						acc = { ...acc, [dataRow[brandColumn.key]]: dataRow };
						return acc;
					}, {})
				).sort((a, b) => b.aop_ach - a.aop_ach)
			);
			setChannelWiseData(
				Object.values(
					distinctChannels.reduce((acc, channel) => {
						let dataRow = { [channelColumn.key]: channel, ...defBqRowData, ...defSqlRowData };
						bqData
							?.filter((row) => row?.[channelColumn.key] === channel && row?.[brandColumn.key] !== "THOR")
							.forEach((bqRow) => (dataRow = setBqDataInRow(bqRow, dataRow)));

						sqlData
							?.filter((row) => row?.[channelColumn.key] === channel && row?.[brandColumn.key] !== "THOR")
							.forEach((sqlRow) => {
								Object.values({ ...achievedColumns, ...projectionColumns })
									.filter((col) => sqlDataUpdateColumnsMap.hasOwnProperty(col.key))
									.forEach((col) => (dataRow = setSQLDataInRow(sqlRow, dataRow)));
							});
						acc = { ...acc, [dataRow[channelColumn.key]]: dataRow };
						return acc;
					}, {})
				).sort((a, b) => b.aop_ach - a.aop_ach)
			);
			setCombinedData((prev) => combineBqAndSqlDataOnBrandChannel(sqlData, bqData));
		} catch (error) {
			setPageLoading(false);
		}
	};

	useEffect(() => {
		fetchPageDataFromScratch();
	}, [pageData]);

	useEffect(() => {
		setDaysLeft((prev) => {
			let days = +moment().set("M", selectedMonth).set("YYYY", selectedYear).endOf("month").diff(moment(), "days");
			if (days > 0) return days;
			return 0;
		});
	}, [selectedMonth, selectedYear]);

	const handleMonthYearChange = (month, year) => {
		setSelectedMonth(month);
		setSelectedYear(year);
	};
	const handleMonthYearModalOpen = () => {
		setMonthYearModal(true);
	};

	return (
		<Stack position="relative" width="90%" maxWidth={1400} margin="auto" spacing={2} alignItems="center">
			<Box display="flex" width="100%" flexWrap="wrap">
				<Box display="flex" justifyContent="flex-end" width="100%" alignItems="center" columnGap="10px">
					<Typography variant="h6">
						{moment().set("M", selectedMonth).format("MMM")} - {selectedYear}
					</Typography>
					<IconButton size="small" onClick={handleMonthYearModalOpen}>
						<EditRounded sx={{ transform: "scale(0.8)" }} />
					</IconButton>
				</Box>
				<Box width="30%" minWidth="200px">
					<Stack
						width="100%"
						height="100px"
						// sx={{ border: "3px solid grey" }}
						alignItems="center"
						justifyContent="center"
						spacing={1}>
						<Box display="flex" width={"80%"} justifyContent="center">
							<Typography sx={{ width: "40%" }} variant="body1" fontWeight={600}>
								Date
							</Typography>
							<Typography sx={{ width: "50%" }} variant="body1" textAlign="right" pr={1}>
								{moment().format("DD-MM-YYYY")}
							</Typography>
						</Box>
						<Box display="flex" width={"80%"} justifyContent="center">
							<Typography sx={{ width: "40%" }} variant="body1" fontWeight={600}>
								Balance
							</Typography>
							<Typography variant="body1" sx={{ width: "50%", background: grey[200] }} pr={1} textAlign="right">
								{daysLeft}
							</Typography>
						</Box>
					</Stack>
					<Typography fontStyle="italic" variant="body2" mt="4px" pl={2}>
						* Value Achieved is till date {moment().format("DD-MM-YYYY")}
					</Typography>
				</Box>
				<Stack
					mt={2}
					width="70%"
					minWidth="200px"
					height={"100px"}
					// sx={{ border: "3px solid grey" }}
					alignItems="center"
					justifyContent="center"
					spacing={1}>
					<Box display="flex" width={"300px"} justifyContent="center" columnGap={2}>
						<Typography
							sx={{ width: "45%", background: grey[200], p: "5px 10px", textAlign: "center" }}
							variant="body2"
							fontWeight={600}>
							Brand
						</Typography>
						<Typography
							sx={{ width: "45%", background: grey[200], p: "5px 10px", textAlign: "center" }}
							variant="body2"
							fontWeight={600}>
							Channel
						</Typography>
					</Box>
				</Stack>
			</Box>
			{/* tables */}
			{/* brand */}
			{!pageLoading ? (
				<>
					<Box display="flex" width="100%" minHeight={200}>
						<Typography sx={{ writingMode: "sideways-lr", textAlign: "center" }}>BRANDWISE</Typography>
						<Box ml={2} flexGrow={1}>
							<Typography textAlign="center" sx={{ background: grey[400] }} height="24px">
								ACHIEVED
							</Typography>
							<Box width="100%">
								<TableDisplay
									columns={[brandColumn, ...Object.values(achievedColumns)]}
									rows={[unitRow, ...brandWiseData]}
									rowHeight="30px"
									// columnWidth="85px"
								/>
							</Box>
						</Box>
						<Box width="100px">
							<Box height={"24px"} />
							<TableDisplay
								columns={[daysLeftColumn]}
								rows={[unitRow, ...brandWiseData.map((row) => ({ [daysLeftColumn.key]: daysLeft }))]}
								rowHeight="30px"
							/>
						</Box>
						<Box flexGrow={1}>
							<Typography textAlign="center" sx={{ background: blueShade }} height="24px">
								PROJECTION
							</Typography>
							<TableDisplay
								columns={Object.values(projectionColumns)}
								rows={[unitRow, ...brandWiseData]}
								rowHeight="30px"
								// columnWidth="85px"
							/>
						</Box>
					</Box>
					{/* Channel */}
					<Box display="flex" flexGrow={1} width="100%" minHeight={200}>
						<Typography sx={{ writingMode: "sideways-lr", textAlign: "center" }}>CHANNELWISE</Typography>

						<Box ml={2} flexGrow={1}>
							<Typography textAlign="center" sx={{ background: grey[400] }} height="24px">
								ACHIEVED
							</Typography>
							<TableDisplay
								columns={[channelColumn, ...Object.values(achievedColumns)]}
								rows={[unitRow, ...channelWiseData]}
								rowHeight="30px"
							/>
						</Box>
						<Box width="100px">
							<Box height={"24px"} />
							<TableDisplay
								columns={Object.values([daysLeftColumn])}
								rows={[unitRow, ...channelWiseData.map((row) => ({ [daysLeftColumn.key]: daysLeft }))]}
								rowHeight="30px"
							/>
						</Box>
						<Box flexGrow={1}>
							<Typography textAlign="center" sx={{ background: blueShade }} height="24px">
								PROJECTION
							</Typography>
							<TableDisplay
								columns={Object.values(projectionColumns)}
								rows={[unitRow, ...channelWiseData]}
								rowHeight="30px"
							/>
						</Box>
					</Box>

					{/* Projected */}
					<Box width="100%" minHeight={200}>
						<Box display="flex" width="100%" justifyContent="space-between" pt={2} pb={1}>
							<Typography variant="h6">PROJECTED</Typography>
							<Box>
								<Button variant="contained" onClick={() => setProjectionEditModal(true)} disabled={daysLeft <= 0}>
									Edit
								</Button>
							</Box>
						</Box>
						<Box display="flex" width="100%">
							<Box flexGrow={1}>
								<Box height={"24px"} />
								<TableDisplay
									columns={[brandColumn, channelColumn]}
									rows={[unitRow, ...combinedData]}
									rowHeight="30px"
								/>
							</Box>
							<Box flexGrow={1}>
								<Typography textAlign="center" sx={{ background: grey[400] }} height="24px">
									ACHIEVED
								</Typography>
								<TableDisplay
									columns={Object.values(achievedColumns)}
									rows={[unitRow, ...combinedData]}
									rowHeight="30px"
								/>
							</Box>
							<Box width="100px">
								<Box height={"24px"} />
								<TableDisplay
									columns={Object.values([daysLeftColumn])}
									rows={[unitRow, ...combinedData.map((row) => ({ [daysLeftColumn.key]: daysLeft }))]}
									rowHeight="30px"
								/>
							</Box>
							<Box flexGrow={1}>
								<Typography textAlign="center" sx={{ background: blueShade }} height="24px">
									PROJECTION
								</Typography>
								<TableDisplay
									columns={Object.values(projectionColumns).map((row) => {
										if (
											[projectionColumns.projected_sales.key, projectionColumns.projected_dis.key].includes(
												row.key
											)
										)
											return { ...row, renderCell: blueRenderCell };
										else return row;
									})}
									rows={[unitRow, ...combinedData]}
									rowHeight="30px"
								/>
							</Box>
						</Box>
					</Box>
				</>
			) : (
				<Stack width="100%" spacing={2}>
					<Skeleton variant="rounded" animation="pulse" width="100%" height={200} />
					<Skeleton variant="rounded" animation="pulse" width="100%" height={200} />
					<Skeleton variant="rounded" animation="pulse" width="100%" height={400} />
				</Stack>
			)}

			<MonthYearSelectorModal
				modalOpen={monthYearModal}
				setModalOpen={setMonthYearModal}
				saveFunction={handleMonthYearChange}
				month={selectedMonth}
				year={selectedYear}
			/>
			<ProjectionEditModal
				modalOpen={projectionEditModal}
				setModalOpen={setProjectionEditModal}
				dataArr={combinedData}
				setDataArr={setCombinedData}
				columns={[
					brandColumn,
					channelColumn,
					...Object.values(achievedColumns),
					daysLeftColumn,
					...Object.values(projectionColumns).map((row) => {
						if ([projectionColumns.projected_sales.key, projectionColumns.projected_dis.key].includes(row.key))
							return { ...row, renderCell: blueRenderCell };
						else return row;
					}),
				].map((col) => ({ ...col, ...converAttrToDatagridCol(col), minWidth: 80 }))}
			/>
		</Stack>
	);
};

export default AopTracker;
